import { VaultTokens } from "../types"

import { ONE_DAY_IN_SECONDS, ONE_SECOND_IN_MILLISECONDS } from "./time"

const WITHDRAWAL_COOLDOWN = ONE_DAY_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS

const VAULT_DEPOSIT_TOKEN_TO_SHARE_TOKEN_NAME: Record<VaultTokens, string> = {
  mBTC: "upmBTC",
  MUSD: "upMUSD",
}

export default {
  WITHDRAWAL_COOLDOWN,
  VAULT_DEPOSIT_TOKEN_TO_SHARE_TOKEN_NAME,
}
